// Multi-file download functionality
document.addEventListener('DOMContentLoaded', function() {
    const multiDownloadButtons = document.querySelectorAll('[data-multi-download]');

    multiDownloadButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();

            const urls = JSON.parse(this.getAttribute('data-multi-download'));

            if (urls && urls.length > 0) {
                // Télécharger chaque fichier avec un petit délai entre chaque
                urls.forEach((url, index) => {
                    setTimeout(() => {
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = '';
                        link.style.display = 'none';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }, index * 200); // 200ms de délai entre chaque téléchargement
                });
            }
        });
    });
});
